import { Link } from 'react-router-dom';
import { newComics, comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 10);

  const categoryNameMap: Record<string, string> = {
    romance: '恋爱', fantasy: '奇幻', action: '动作', comedy: '搞笑',
    thriller: '悬疑', drama: '剧情', daily: '日常', school: '校园', workplace: '职场',
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="flex-1">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-display font-bold text-foreground-900">
                  <i className="ri-timer-line text-secondary-500 mr-2"></i>
                  最新更新
                </h2>
                <p className="text-sm text-foreground-500 mt-1">每日更新，精彩不停</p>
              </div>
            </div>

            <div className="space-y-3">
              {latestComics.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="flex items-center gap-4 p-3 rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 group"
                >
                  <span className="text-lg font-bold text-foreground-300 w-6 text-center">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div className="w-12 h-16 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={comic.cover}
                      alt={comic.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {comic.author} · 更新至第{comic.chapters.length}话
                    </p>
                  </div>
                  <div className="hidden sm:flex flex-wrap gap-1">
                    {comic.categories.slice(0, 2).map((cat) => (
                      <span key={cat} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                        {categoryNameMap[cat] || cat}
                      </span>
                    ))}
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap hidden md:block">
                    {comic.updatedAt}
                  </span>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-80">
            <div className="sticky top-24">
              <h3 className="text-lg font-display font-bold text-foreground-900 mb-4">
                <i className="ri-sparkling-line text-accent-500 mr-2"></i>
                新作上架
              </h3>
              <div className="space-y-4">
                {newComics.map((comic) => (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.id}`}
                    className="flex items-center gap-3 p-3 rounded-xl bg-accent-50 border border-accent-200 hover:border-accent-300 transition-all duration-300 group"
                  >
                    <div className="w-14 h-20 rounded-lg overflow-hidden flex-shrink-0">
                      <img
                        src={comic.cover}
                        alt={comic.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="min-w-0">
                      <span className="text-xs px-1.5 py-0.5 rounded bg-accent-500 text-background-50 font-medium">
                        NEW
                      </span>
                      <h4 className="text-sm font-semibold text-foreground-900 mt-1 group-hover:text-accent-600 transition-colors truncate">
                        {comic.title}
                      </h4>
                      <p className="text-xs text-foreground-500 mt-0.5">
                        {comic.author}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}